import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/admin.css";

function Admin() {
  const { usuario, logout } = useAuth();
  const navigate = useNavigate();

  // Normaliza links do YouTube para sempre armazenar um src valido de iframe
  function normalizarYoutube(valor) {
    let link = valor.trim();

    // Se o usuario colar o codigo completo do iframe, captura apenas o src
    const iframeSrc = link.match(/src=["']([^"']+)["']/i);
    if (iframeSrc) {
      link = iframeSrc[1];
    }

    // Extrai o ID do video de formatos comuns e gera o link embed
    const idMatch = link.match(
      /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/))([\w-]{11})/
    );
    if (idMatch) {
      link = `https://www.youtube.com/embed/${idMatch[1]}`;
    }

    return link;
  }

  const [itens, setItens] = useState([]);
  const [form, setForm] = useState({
    titulo: "",
    descricao: "",
    info: "",
    apresentacao: { tipo: "imagem", arquivo: "" },
    tags: [],
    disponibilidade: [],
  });
  const [tagTemp, setTagTemp] = useState("");
  const [dispTemp, setDispTemp] = useState({ tipo: "Youtube", link: "" });
  const [editId, setEditId] = useState(null);

  function handleLogout() {
    logout();
    navigate("/");
  }

  function limparForm() {
    setForm({
      titulo: "",
      descricao: "",
      info: "",
      apresentacao: { tipo: "imagem", arquivo: "" },
      tags: [],
      disponibilidade: [],
    });
    setTagTemp("");
    setDispTemp({ tipo: "Youtube", link: "" });
    setEditId(null);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.titulo.trim() || !form.descricao.trim() || !form.info.trim()) {
      return;
    }
    if (editId !== null) {
      setItens((prev) =>
        prev.map((it) => (it.id === editId ? { ...form, id: editId } : it))
      );
    } else {
      const novo = { ...form, id: Date.now() };
      setItens((prev) => [...prev, novo]);
    }
    limparForm();
  }

  function adicionarTag() {
    if (tagTemp.trim()) {
      setForm((f) => ({ ...f, tags: [...f.tags, tagTemp.trim()] }));
      setTagTemp("");
    }
  }

  function removerTag(index) {
    setForm((f) => ({
      ...f,
      tags: f.tags.filter((_, i) => i !== index),
    }));
  }

  function adicionarDisponibilidade() {
    if (dispTemp.link.trim()) {
      const linkNormalizado =
        dispTemp.tipo === "Youtube"
          ? normalizarYoutube(dispTemp.link)
          : dispTemp.link.trim();

      setForm((f) => ({
        ...f,
        disponibilidade: [
          ...f.disponibilidade,
          { ...dispTemp, link: linkNormalizado },
        ],
      }));
      setDispTemp({ tipo: "Youtube", link: "" });
    }
  }

  function removerDisponibilidade(index) {
    setForm((f) => ({
      ...f,
      disponibilidade: f.disponibilidade.filter((_, i) => i !== index),
    }));
  }

  function editarItem(item) {
    setForm({
      titulo: item.titulo,
      descricao: item.descricao,
      info: item.info,
      apresentacao: { ...item.apresentacao },
      tags: [...item.tags],
      disponibilidade: [...item.disponibilidade],
    });
    setEditId(item.id);
  }

  function deletarItem(id) {
    setItens((prev) => prev.filter((it) => it.id !== id));
    if (editId === id) limparForm();
  }

  return (
    <div className="admin-container">
      <div className="admin-content">
        <h1 style={{textAlign: "center"}}>Você está na área administrativa.</h1>

        <form className="admin-form" onSubmit={handleSubmit}>
          <h2>{editId !== null ? "Editar Item" : "Novo Item"}</h2>

          <label style={{color: "blue"}}>Título*</label>
          <input
            type="text"
            value={form.titulo}
            onChange={(e) => setForm({ ...form, titulo: e.target.value })}
            required
          />

          <label style={{color: "blue"}}>Descrição*</label>
          <textarea
            value={form.descricao}
            onChange={(e) => setForm({ ...form, descricao: e.target.value })}
            required
          />

          <label style={{color: "blue"}}>Info*</label>
          <textarea
            value={form.info}
            onChange={(e) => setForm({ ...form, info: e.target.value })}
            required
          />

          <fieldset>
            <label style={{color: "blue"}}>Tipo</label>
            <select
              value={form.apresentacao.tipo}
              onChange={(e) =>
                setForm({
                  ...form,
                  apresentacao: { ...form.apresentacao, tipo: e.target.value },
                })
              }
            >
              <option value="imagem">Imagem</option>
              <option value="video">Vídeo</option>
            </select>
            <label style={{color: "blue"}}>Arquivo</label>
            <input style={{marginLeft: "3%"}}
              type="file"
              value={form.apresentacao.arquivo}
              onChange={(e) =>
                setForm({
                  ...form,
                  apresentacao: { ...form.apresentacao, arquivo: e.target.value },
                })
              }
            />
            
          </fieldset>

          <fieldset>
            <label style={{color: "blue"}}>Tags</label>
            <div className="tag-input-group">
              <input
                type="text"
                value={tagTemp}
                onChange={(e) => setTagTemp(e.target.value)}
              />
              <button type="button" onClick={adicionarTag}>
                Adicionar tag
              </button>
            </div>
            <ul className="tag-list">
              {form.tags.map((t, i) => (
                <li key={i}>
                  {t}{" "}
                  <button type="button" onClick={() => removerTag(i)}>
                    x
                  </button>
                </li>
              ))}
            </ul>
          </fieldset>

          <fieldset>
            <label style={{color: "blue"}}>Disponibilidade</label>
            <div className="disp-input-group">
              <select
                value={dispTemp.tipo}
                onChange={(e) =>
                  setDispTemp((d) => ({ ...d, tipo: e.target.value }))
                }
              >
                <option>Youtube</option>
                <option>APK</option>
                <option>RD</option>
                <option>Download</option>
                <option>Space</option>
              </select>
              <input
                type="text"
                placeholder="Link"
                value={dispTemp.link}
                onChange={(e) =>
                  setDispTemp((d) => ({ ...d, link: e.target.value }))
                }
              />
              <button type="button" onClick={adicionarDisponibilidade}>
                Adicionar
              </button>
            </div>
            <ul className="disp-list">
              {form.disponibilidade.map((d, i) => (
                <li key={i}>
                  {d.tipo}: {d.link}{" "}
                  <button type="button" onClick={() => removerDisponibilidade(i)}>
                    x
                  </button>
                </li>
              ))}
            </ul>
          </fieldset>

          <div className="form-actions" style={{justifyContent: "center"}}>
            <button type="submit">{editId !== null ? "Salvar" : "Criar"}</button>
            {editId !== null && (
              <button type="button" onClick={limparForm}>
                Cancelar
              </button>
            )}
          </div>
        </form>

        <div className="admin-list">
          <h2>Itens ({itens.length})</h2>
          <ul>
            {itens.map((item) => (
              <li key={item.id} className="admin-item">
                <strong>{item.titulo}</strong> ({item.apresentacao.tipo})
                <div className="item-actions">
                  <button onClick={() => editarItem(item)}>Editar</button>
                  <button onClick={() => deletarItem(item.id)}>Deletar</button>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="admin-actions">
          <button onClick={() => navigate("/")} className="btn-voltar">
            Voltar à Página Inicial
          </button>
          <button onClick={handleLogout} className="btn-sair">
            Fazer Logout
          </button>
        </div>
      </div>
    </div>
  );
}

export default Admin;
